export const IconTransfer = ({ color }: { color: string }) => {
  return (
    <svg
      enableBackground="new 0 0 24 24"
      style={{ maxWidth: '35px', minWidth: '35px' }}
      viewBox="0 0 24 24"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M14.8,9.2l2.8,2.8 M17.6,12l-2.8,2.8 M17.6,12H9.9"
          fill="none"
          stroke={color}
        />
        <line fill="none" stroke={color} x1="6.2" x2="6.2" y1="9.1" y2="14.9" />
      </g>
    </svg>
  );
};
